<template>
    <div>
        <draggable class="d-flex flex-wrap form-group row" v-model="keyResults"
                   :options="{draggable:'.key-result-item', filter: '.btn'}" @end="saveOrder">
            <key-result
                    v-model="keyResults[key]"
                    :results="results"
                    :key="keyResult.id"
                    v-for="(keyResult, key) in keyResults"
                    style="margin-bottom: 10px"
                    class="key-result-item"
                    ref="keyResults"
                    :id="'key-result-'+keyResult.id"
                    @delete="remove(key)"
                    @edit="closeOthers(key)"/>

            <div class="d-flex col-md-4" style="margin-bottom: 10px" slot="footer">
                <div class="card">
                    <div class="card-body d-flex flex-column">
                        <a href="#" class="btn btn-success" style="margin-top: auto;"
                           @click.prevent="showCreateModal = true">Hinzufügen</a>
                    </div>
                </div>
            </div>
        </draggable>
        <b-modal ref="modal" v-model="showCreateModal" @ok="add">
            <h1 slot="modal-title">Result hinzufügen</h1>
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" id="name" v-model="keyResultName" class="form-control">
            </div>
        </b-modal>
    </div>
</template>
<script>
import KeyResult from "./KeyResult";

export default {
  components: {
    KeyResult
  },
  props: ["value", "results"],
  data() {
    return {
      showCreateModal: false,
      keyResults: this.value,
      keyResultName: ""
    };
  },
  methods: {
    add() {
      let form = new FormData();
      form.append("create_key_result[name]", this.keyResultName);
      axios
        .post("/api/" + store.state.language + "/key_result/create", form)
        .then(({ data }) => {
          this.keyResults.push(data.result);
          this.keyResultName = "";
          this.$emit("input", this.keyResults);
        });
    },
    remove(key) {
      /**
       * TODO: delete from db
       */
      this.keyResults.splice(key, 1);
      this.$emit("input", this.keyResults);
    },
    closeOthers(key) {
      for (let i = 0; i < this.keyResults.length; i++) {
        if (i != key) {
          this.$refs.keyResults[i].stopEdit();
        }
      }
      this.$nextTick(() => {
        this.$scrollTo("#key-result-" + this.keyResults[key].id, 500);
      });
    },
    saveOrder() {
      let ids = [];
      for (let i = 0; i < this.keyResults.length; i++) {
        ids.push(this.keyResults[i].id);
      }
      store.commit("addSavingProcess");
      axios
        .post(
          "/api/" + store.state.language + "/key_result/set_key_result_order",
          { blocks: ids }
        )
        .finally(() => {
          store.commit("finishSavingProcess");
        });
    }
  }
};
</script>
<style>
.not-edit.key-result-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/KeyResults.vue